import React from 'react';
import { Trophy } from 'lucide-react';
import type { GameAchievements } from '../types';

interface GameAchievementsProps {
  game: GameAchievements;
}

export function GameAchievementsCard({ game }: GameAchievementsProps) {
  const achievedCount = game.unlockedAchievements;
  const totalCount = game.totalAchievements;
  const percentage = (achievedCount / totalCount) * 100;

  return (
    <div className="bg-white rounded-lg shadow p-4">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <img
            src={`https://cdn.cloudflare.steamstatic.com/steam/apps/${game.appid}/capsule_sm_120.jpg`}
            alt={game.name}
            className="w-12 h-12 rounded object-cover"
          />
          <div>
            <h3 className="font-medium text-gray-900">{game.name}</h3>
            <div className="flex items-center gap-2 text-sm text-gray-500">
              <Trophy className="w-4 h-4" />
              <span>{achievedCount} of {totalCount}</span>
            </div>
          </div>
        </div>
        <span className="font-medium text-gray-900">
          {percentage.toFixed(1)}%
        </span>
      </div>
      <div className="relative">
        <div className="h-2 bg-gray-200 rounded-full">
          <div
            className="h-2 bg-yellow-500 rounded-full transition-all duration-500"
            style={{ width: `${percentage}%` }}
          />
        </div>
      </div>
    </div>
  );
}